/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: BI Dashboard
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

define([
	'underscore',
	'../../../lib/@waca/core-client/js/core-client/ui/core/Class',
	'../../../lib/@waca/upgrades/UpgradeBase',
	'./utils/WidgetUpgradeUtils'
], function(_, Class, UpgradeBase, WidgetUpgradeUtils) {
	'use strict';

	var Upgrade = Class.extend([UpgradeBase], {
		init: function() {
			this.VERSION = 1008;
		},

		/**
		 * Perform upgrade
		 *
		 * @param {object} spec - spec to perform upgrade on
		 *
		 * @return {Promise} Promise to be resolved when upgrade performed
		 */
		up: function(spec) {
			if (spec.widgets) {
				this._upgradeWidgets(spec);
			}
			return Promise.resolve(spec);
		},

		_supportsAxisLabelVerticalProperty: function(widget) {
			const supportedVisIds = ['com.ibm.vis.rave2line', 'com.ibm.vis.rave2point'];
			return supportedVisIds.indexOf(widget.visId) > -1;
		},

		_upgradeWidgets: function(spec) {
			_.each(spec.widgets, (widget) => {
				// itemAxis.labels.vertical property is only available for line and point visualization
				// check the visId before upgrading the property
				if (this._supportsAxisLabelVerticalProperty(widget)) {
					this._upgradeItemAxisLabelVerticalProperty(widget);
				}
			});
		},

		_upgradeItemAxisLabelVerticalProperty: function(model){
			/*
			Pre R8, the property name for label orientation is 'itemAxis.labels.vertical' and it is a boolean property with default value to false.
			The property has been upgrader starting from R9 using the name as 'itemAxis.labels.layoutMode' which is an enum type property.
			The scenarios that need to be considered are:
			1) Upgrade from pre R8, which should be set the new prop value as 'horizontal' for default true value,set new prop as 'rotate90' for vertical value to true
			2) Upgrade from R9, R10 or R11, which need to check if the new property exists, if so using the new property values and clean the old one
			3) Upgrade from R12 or R13 with default value 'automatic', the spec version for R12 is 1008, which is already higher then this upgrader, so this scenario is safe, since from here the prop has the same behavior as endor
			*/
			const deprecatedPropName = 'itemAxis.labels.vertical';
			const newPropName = 'itemAxis.labels.layoutMode';
			const oldProp = WidgetUpgradeUtils.findProperty(deprecatedPropName, model.properties);
			const newProp = WidgetUpgradeUtils.findProperty(newPropName, model.properties);

			// remove the old property as its no longer being used
			model.properties = _.filter(model.properties, function(prop){
				return prop.id !== deprecatedPropName;
			});

			// if new prop exists just return
			if (newProp) {
				return;
			}

			// if the oldProp does not exist or set value false, set the new prop as 'horizontal', otherwise set as 'rotate90'
			const propValue = oldProp && oldProp.value ? 'rotate90':'horizontal';
			model.properties.push({
				id: newPropName,
				value: propValue
			});

		},

		down: function(spec) {
			return Promise.resolve(spec);
		}
	});

	return new Upgrade();
});
